import React from 'react';
const VideoSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M16.4728 5.16669C16.6786 3.99239 15.775 2.91669 14.5828 2.91669H4.75138C3.55919 2.91669 2.65559 3.99239 2.86134 5.16669"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M14.6183 2.91669C14.6438 2.68351 14.6566 2.5669 14.6568 2.4706C14.6589 1.54934 13.9649 0.775263 13.0488 0.676965C12.9531 0.666687 12.8358 0.666687 12.6013 0.666687H6.73525C6.50067 0.666687 6.38337 0.666687 6.28761 0.676965C5.37161 0.775263 4.67768 1.54934 4.67969 2.47059C4.6799 2.5669 4.69267 2.6835 4.7182 2.91669"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M11.9903 11.121C12.4928 11.4326 12.4928 12.2391 11.9903 12.5507L8.95583 14.4317C8.4674 14.7345 7.86719 14.3405 7.86719 13.717V9.95469C7.86719 9.33126 8.4674 8.93715 8.95583 9.23991L11.9903 11.121Z"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M1.01313 11.2804C0.611701 8.43315 0.410992 7.00957 1.26406 6.08813C2.11712 5.16669 3.63579 5.16669 6.67312 5.16669H12.6628C15.7001 5.16669 17.2188 5.16669 18.0719 6.08813C18.9249 7.00957 18.7242 8.43315 18.3228 11.2804L17.9421 13.9804C17.6273 16.2132 17.47 17.3296 16.6625 17.9982C15.855 18.6667 14.664 18.6667 12.2821 18.6667H7.05379C4.6719 18.6667 3.48095 18.6667 2.67348 17.9982C1.866 17.3296 1.7086 16.2132 1.3938 13.9804L1.01313 11.2804Z"
        stroke={color}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export default VideoSVG;
